import Vue from 'vue';
import Toaster from 'v-toaster';
import Select2 from 'v-select2-component';
import store from './store'

import {
    BootstrapVue,
    IconsPlugin
 } from 'bootstrap-vue'


window.axios = require('axios');

Vue.use(Toaster, { timeout: 2000 })
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.component('Select2', Select2);

Vue.component('add-to-cart', () => import('./components/add-to-cart'));
Vue.component('change-quantity', () => import('./components/change-quantity'));
Vue.component('cart', () => import('./components/cart'));
Vue.component('category-select', () => import('./components/category_select'));

const app = new Vue({
    el: '#app',
    store
});

// The order used to be placed from a second copy of makeOrder() here. It could
// never run: a function declared in a module is not on window, so the button's
// onclick always reached the one the checkout page defines - and this copy still
// carried a Blade tag, which in a compiled bundle is a literal string. The
// checkout owns placing the order; this file owns the components.

// Select the <b-collapse> element
const navCollapse = document.querySelector('#nav-collapse');

// Function to toggle the class based on screen width
function toggleClass() {
    if (window.innerWidth > 768) {
        navCollapse.classList.add('content_wrapper', 'mt-0');
    } else {
        navCollapse.classList.remove('content_wrapper', 'mt-0');
    }
}

// Call the function initially to set the class on page load
toggleClass();

// Add an event listener to handle screen resize
window.addEventListener('resize', toggleClass);
